import { KeyboardEvent } from 'react'

/**
 * Returns a keydown handler that prevents the specified keys from being entered.
 *
 * Usage:
 *   <TextInput onKeyDown={blockKeys('\\')} />
 *   <TextInput onKeyDown={blockKeys('\\', '/', '?')} />
 */
export function blockKeys(...keys: string[]) {
  return (e: KeyboardEvent<HTMLInputElement>) => {
    if (keys.includes(e.key)) {
      e.preventDefault()
    }
  }
}
